import styled from "styled-components";

import { rem, size } from "@styles/Utilities.styled";

import "react-phone-input-2/lib/style.css";


export const StyledCustomPhoneInput = styled.div`
  &.read-only {
    .flag-dropdown {
      pointer-events: none;
      background-color: rgb(0, 0, 0, 0) !important;
      border-color: rgb(0, 0, 0, 0) !important;

      .arrow {
        display: none;
      }
    }
  }

  &.has-phone {
    .form-control {
      &:read-only {
        padding-left: 3em !important;
      }
    }
  }

  .form-control {
    ${size("100%")}
    font-size: ${rem(13)};
    padding: 0.6em 1em 0.6em 4em !important;
    color: var(--clr-primary-700);
    border-radius: var(--border-radius-2);
    border: 1px solid var(--clr-gray-200);
    font-family: var(--font-primary);
    transition: padding 0.2s;

    &::placeholder {
      color: var(--clr-gray-400);
      font-family: inherit;
      margin-left: -2rem;
    }

    &:read-only {
      background-color: rgb(0, 0, 0, 0) !important;
      border: none !important;
      pointer-events: none;
      padding-left: 0em !important;
    }

    &:focus &:not(:read-only) {
      box-shadow: inset 0 0 0 1px var(--clr-primary-400);
      border-color: rgb(0, 0, 0, 0);
    }
    /* &.invalid-number {
      box-shadow: inset 0 0 0 1px #d79f9f;
    } */
  }

  .country-list {
    width: var(--phone-input-width);
    border: 1px solid var(--clr-gray-200);
    box-shadow: none;

    .country {
      &.highlight:not(&:hover) {
        background-color: var(--clr-primary-400);
        color: var(--clr-white);

        .dial-code {
          color: var(--clr-white);
        }
      }

      &:hover {
        background-color: var(--clr-gray-100);
        /* color: var(--clr-white); */

        .dial-code {
          /* color: var(--clr-white); */
        }
      }
    }
  }
`;
